<template>
  <div class="card-guide">
    <div class="card-guide-body">
      <div class="d-flex justify-content-between">
        <span class="add-events" @click="showAddEvent">+ Add Event</span>
        <span class="search">
          <label>
            <svg
              width="16"
              height="17"
              viewBox="0 0 16 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.3335 3.16659C4.75617 3.16659 2.66683 5.25592 2.66683 7.83325C2.66683 10.4106 4.75617 12.4999 7.3335 12.4999C9.91083 12.4999 12.0002 10.4106 12.0002 7.83325C12.0002 5.25592 9.91083 3.16659 7.3335 3.16659ZM1.3335 7.83325C1.3335 4.51954 4.01979 1.83325 7.3335 1.83325C10.6472 1.83325 13.3335 4.51954 13.3335 7.83325C13.3335 11.147 10.6472 13.8333 7.3335 13.8333C4.01979 13.8333 1.3335 11.147 1.3335 7.83325Z"
                fill="#B3C2CB"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M10.6284 11.1286C10.8887 10.8683 11.3108 10.8683 11.5712 11.1286L14.4712 14.0286C14.7315 14.289 14.7315 14.7111 14.4712 14.9714C14.2108 15.2318 13.7887 15.2318 13.5284 14.9714L10.6284 12.0714C10.368 11.8111 10.368 11.389 10.6284 11.1286Z"
                fill="#B3C2CB"
              />
            </svg>
            <input
              type="search"
              class="search-input"
              placeholder="Search Companies"
              v-model="searchStr"
            /> </label
        ></span>
      </div>
      <div class="events" role="tablist">
        <b-card no-body>
          <b-table
            id="table-transition-example"
            :items="events"
            :fields="fields"
            small
            primary-key="a"
            :tbody-transition-props="transProps"
            show-empty
          >
            <template #table-busy>
              <b-skeleton-table
                :rows="skeletonRows"
                :columns="filteredFields.length"
                :table-props="{ bordered: true, striped: true }"
              />
            </template>
            <template #empty="scope">
              No Data Available
            </template>
            <template #cell(index)="data">
              {{ data.index + 1 }}
            </template>
            <template #cell(imgURL)="row">
              <b-avatar
                v-if="row.item.event && row.item.event.imgURL"
                variant="info"
                :src="row.item.event.imgURL"
                class="mr-3"
              >
              </b-avatar>
            </template>
            <template #cell(spheres)="row">
              <svg
                v-if="
                  row.item.profile &&
                    row.item.profile.expertise &&
                    row.item.profile.expertise.includes('s')
                "
                class="mr-1"
                height="31"
                viewBox="0 0 31 31"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.5 31C24.0604 31 31 24.0604 31 15.5C31 6.93959
                24.0604 0 15.5 0C6.93958 0 0 6.93959 0 15.5C0 24.0604 6.93958 31
                15.5 31Z"
                  fill="var(--theme-color)"
                />
                <path
                  d="M16.8568 7.25651C16.7516 7.25492 16.6502 7.29588 16.5764 7.37083L14.5994 9.3367C14.5274 9.40868 14.4614 9.48604 14.395 9.56309C13.6597 8.95221 12.7373 8.60899 11.7789 8.60976H10.8973C10.6823 8.60976 10.5052 8.78694 10.5052 9.00196V10.5052H9.00191C8.78689 10.5052 8.61013 10.682 8.61013 10.897V11.7786C8.61021 12.0739 8.65073 12.3671 8.71363 12.6555C8.44879 12.8217 8.19786 13.01 7.97689 13.2314L7.3712 13.8371C7.2192 13.9891 7.2192 14.2391 7.3712 14.3911L9.36256 16.3828C9.4328 16.4531 9.50822 16.5171 9.58306 16.5816C8.95993 17.3204 8.60936 18.252 8.61013 19.2211V20.1026C8.61015 20.3176 8.78689 20.4944 9.00191 20.4944H10.5052V21.9977C10.5052 22.2127 10.6824 22.3898 10.8974 22.3898H11.7789C12.0865 22.3898 12.3914 22.3462 12.6912 22.2781C12.8553 22.5379 13.0405 22.7844 13.258 23.0017L13.8657 23.6252C13.9386 23.7001 14.0385 23.7426 14.1431 23.7434H14.1456C14.2491 23.7434 14.3487 23.7024 14.4221 23.6294L16.4001 21.6629V21.6627C16.4719 21.5906 16.5379 21.5134 16.6042 21.4363C17.3397 22.0475 18.2619 22.3907 19.2207 22.3899H20.1021C20.3172 22.3899 20.4943 22.2128 20.4943 21.9977V20.4945H21.9976C22.2127 20.4945 22.3894 20.3177 22.3894 20.1027V19.2208C22.3894 18.9255 22.3488 18.6325 22.2859 18.3442C22.5507 18.178 22.8013 17.9899 23.0223 17.7685L23.6283 17.1625C23.7804 17.0105 23.7804 16.7603 23.6283 16.6082L21.6369 14.6165C21.5667 14.5464 21.4913 14.4825 21.4165 14.418C22.0396 13.6792 22.3902 12.7477 22.3894 11.7787V10.8971C22.3894 10.6821 22.2127 10.5053 21.9976 10.5053H20.4943V9.00194C20.4943 8.78692 20.3172 8.60983 20.1021 8.60983H19.2207C18.9131 8.60986 18.6077 8.65337 18.308 8.72155C18.1442 8.46208 17.9596 8.21605 17.7425 7.99895L17.7406 7.99768L17.1329 7.37431C17.0601 7.29954 16.9602 7.25732 16.8558 7.25635L16.8568 7.25651ZM16.8489 8.20525L17.183 8.54787L17.1859 8.55072C18.4849 9.85272 18.4848 11.9568 17.1859 13.2589L16.8058 13.6389C16.5318 13.446 16.2213 13.317 15.8912 13.2591V12.7229C15.8912 11.7705 15.5541 10.8533 14.95 10.1199C15.0151 10.0417 15.0806 9.96392 15.1525 9.89192V9.89165L16.8489 8.20525ZM11.2887 9.39373H11.7782C13.6175 9.39563 15.1054 10.8837 15.1074 12.723V13.2616C14.2636 13.4116 13.5855 14.0165 13.3319 14.8326C12.1048 14.3109 11.2922 13.1198 11.2887 11.7786V11.7783V9.39373ZM19.2207 9.39373H19.7105V10.5052H19.2207C19.1198 10.5053 19.0191 10.5132 18.9186 10.5206C18.8849 10.1539 18.8001 9.79533 18.67 9.45102C18.8524 9.42046 19.0356 9.39378 19.2207 9.39373V9.39373ZM9.39369 11.2888H10.5049V11.7786C10.5049 11.8708 10.5121 11.9612 10.5183 12.0518C10.1505 12.0835 9.79054 12.1665 9.4448 12.2955C9.41791 12.1242 9.39381 11.9521 9.39373 11.7786L9.39369 11.2888ZM19.2207 11.2888H21.6055V11.7786C21.6036 13.6178 20.1158 15.1056 18.2766 15.1078H17.74C17.6822 14.7777 17.5536 14.467 17.3606 14.1929L17.74 13.8135V13.8132C18.4156 13.1413 18.826 12.2534 18.917 11.3072C19.0179 11.2979 19.119 11.289 19.2203 11.2889L19.2207 11.2888ZM10.6523 12.8262C10.9054 13.7741 11.4905 14.5876 12.2922 15.1452C11.5056 15.2281 10.7597 15.5294 10.1432 16.0297C10.0654 15.9651 9.98817 15.8999 9.9165 15.8285L8.20228 14.1139L8.53112 13.785C9.09703 13.2148 9.85237 12.8789 10.652 12.8262H10.6523ZM15.5053 13.9926C15.5587 13.9932 15.6119 13.9969 15.6647 14.0032C15.8056 14.0201 15.9437 14.0567 16.0748 14.111C16.5994 14.3282 17.0029 14.8248 17.0029 15.4997C17.001 16.3309 16.3309 17.0018 15.4997 17.003C14.8248 17.003 14.3279 16.5998 14.1106 16.0752C13.8933 15.5506 13.9595 14.9141 14.4366 14.437C14.7497 14.1239 15.1316 13.9877 15.5053 13.9926V13.9926ZM20.856 14.9699H20.8561C20.9338 15.0346 21.011 15.0997 21.0827 15.1711L22.7973 16.8854L22.4681 17.2145C21.9021 17.7846 21.1468 18.1207 20.3473 18.1734C20.0942 17.2256 19.509 16.4121 18.7074 15.8544C19.494 15.7715 20.2397 15.4702 20.8563 14.9699H20.856ZM12.7226 15.8918H12.7227H13.2589C13.3168 16.2219 13.4457 16.5324 13.6386 16.8064L13.2592 17.1861C12.5834 17.858 12.1729 18.7458 12.0819 19.6921C11.9809 19.7015 11.8797 19.7103 11.7782 19.7105H9.39369V19.221C9.39559 17.3819 10.8835 15.8941 12.7226 15.8918V15.8918ZM17.6673 16.1669C18.8946 16.6887 19.7072 17.8797 19.7105 19.2211V21.6059H19.2207C17.3814 21.604 15.8935 20.116 15.8914 18.2766V17.7381C16.7354 17.5882 17.4137 16.9831 17.6673 16.1669ZM14.1929 17.3607C14.467 17.5536 14.7776 17.6825 15.1078 17.7403V18.2766C15.1078 19.2289 15.4448 20.1459 16.0486 20.8793C15.9837 20.9576 15.9183 21.0355 15.8465 21.1076L14.1503 22.7944L13.8145 22.4498C13.8145 22.4501 13.8145 22.4491 13.8145 22.4495V22.4492V22.4489C12.5134 21.1478 12.5134 19.042 13.8145 17.7409L14.1929 17.3607ZM21.5544 18.7038C21.5813 18.8752 21.6054 19.0474 21.6055 19.2211V19.7105H20.4944V19.2211C20.4944 19.1287 20.4871 19.0382 20.4809 18.9475C20.8488 18.9159 21.2085 18.8328 21.5543 18.7038H21.5544ZM12.0806 20.479C12.1143 20.8456 12.1987 21.2042 12.3288 21.5485C12.1466 21.5791 11.9635 21.6059 11.7785 21.6059H11.2888V20.4944H11.7785C11.8794 20.4943 11.9801 20.4863 12.0806 20.4789V20.479Z"
                  fill="white"
                />
              </svg>
              <svg
                v-if="
                  row.item.profile &&
                    row.item.profile.expertise &&
                    row.item.profile.expertise.includes('h')
                "
                class="mr-1"
                width="31"
                height="31"
                viewBox="0 0 31 31"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.5 31C24.0604 31 31 24.0604 31 15.5C31 6.93959 24.0604 0 15.5 0C6.93959 0 0 6.93959 0 15.5C0 24.0604 6.93959 31 15.5 31Z"
                  fill="#FF8C7D"
                />
                <path
                  d="M11.7163 7.92725C10.4068 7.92725 9.20456 8.45094 8.32717 9.40254C7.46019 10.343 6.98157 11.6289 6.98157 13.0251C6.98157 14.4615 7.51479 15.7744 8.66947 17.1677C9.70254 18.4142 11.1926 19.6848 12.9201 21.157C12.921 21.1577 12.922 21.1585 12.9229 21.1593C13.5122 21.6614 14.1799 22.231 14.8729 22.837C15.0462 22.9888 15.2686 23.072 15.4994 23.072C15.73 23.072 15.9527 22.9885 16.1258 22.837C16.8204 22.2295 17.4891 21.6595 18.0793 21.1566C19.8066 19.6845 21.2965 18.4139 22.3296 17.1673C23.4843 15.7741 24.0179 14.4615 24.0179 13.0251C24.0179 11.6289 23.5392 10.343 22.6722 9.40254C21.7949 8.45094 20.5925 7.92725 19.2831 7.92725C18.305 7.92725 17.4115 8.23585 16.6225 8.84606C16.2242 9.15407 15.863 9.53126 15.5441 9.97199C15.539 9.97904 15.5323 9.98476 15.5245 9.98871C15.5167 9.99267 15.5081 9.99473 15.4993 9.99473C15.4906 9.99473 15.482 9.99267 15.4742 9.98871C15.4665 9.98476 15.4597 9.97904 15.4545 9.97199C15.1358 9.53126 14.7747 9.15407 14.3766 8.84606C13.5876 8.23586 12.6941 7.92725 11.716 7.92725H11.7163ZM11.7163 8.82091C12.4902 8.82091 13.2031 9.06806 13.8299 9.55266C14.3887 9.98484 14.7755 10.5286 15.0026 10.9093C15.1085 11.0868 15.2933 11.1918 15.4997 11.1918C15.7061 11.1918 15.8909 11.0868 15.9968 10.9093C16.224 10.5286 16.6108 9.98484 17.1695 9.55266C17.7962 9.06806 18.5091 8.82091 19.283 8.82091C20.3381 8.82091 21.31 9.2429 22.0155 10.0081C22.7315 10.7849 23.1245 11.8567 23.1245 13.0251C23.1245 14.2586 22.6636 15.3649 21.6422 16.5974C20.6547 17.789 19.1921 19.0345 17.5004 20.4763C16.9078 20.9811 16.2364 21.5535 15.5347 22.1646C15.5245 22.1734 15.5116 22.1783 15.4981 22.1783C15.4847 22.1783 15.4717 22.1734 15.4616 22.1646C14.765 21.5556 14.0961 20.9849 13.5052 20.4814L13.5021 20.479C13.5011 20.4783 13.5001 20.4775 13.4992 20.4767C11.8074 19.0349 10.3445 17.789 9.35706 16.5975C8.33555 15.3649 7.87469 14.2586 7.87469 13.0252C7.87469 11.8568 8.26769 10.7849 8.98374 10.0082C9.68935 9.24293 10.661 8.82092 11.7162 8.82092L11.7163 8.82091Z"
                  fill="white"
                />
              </svg>
              <svg
                v-if="
                  row.item.profile &&
                    row.item.profile.expertise &&
                    row.item.profile.expertise.includes('e')
                "
                class="mr-1"
                width="31"
                height="31"
                viewBox="0 0 31 31"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.5 31C24.0604 31 31 24.0604 31 15.5C31 6.93959 24.0604 0 15.5 0C6.93959 0 0 6.93959 0 15.5C0 24.0604 6.93959 31 15.5 31Z"
                  fill="#65EA82"
                />
                <path
                  d="M10.1106 21.1949C9.85899 21.1949 9.65503 20.9909 9.65503 20.7393V10.0889C9.65503 9.05258 10.4982 8.20947 11.5345 8.20947H20.8885C21.1401 8.20947 21.344 8.41348 21.344 8.6651V19.1446C21.344 19.3962 21.1401 19.6002 20.8885 19.6002C20.6368 19.6002 20.4328 19.3962 20.4328 19.1446V9.12073H11.5345C11.0006 9.12073 10.5663 9.55506 10.5663 10.0889V20.7393C10.5663 20.9909 10.3623 21.1949 10.1106 21.1949V21.1949Z"
                  fill="white"
                />
                <path
                  d="M20.8885 22.7901H11.7054C10.5748 22.7901 9.65503 21.8703 9.65503 20.7398C9.65503 19.6092 10.5748 18.6895 11.7054 18.6895H20.8885C21.1401 18.6895 21.344 18.8935 21.344 19.1451C21.344 19.3967 21.1401 19.6007 20.8885 19.6007H11.7054C11.0773 19.6007 10.5663 20.1117 10.5663 20.7398C10.5663 21.3679 11.0773 21.8788 11.7054 21.8788H20.8885C21.1401 21.8788 21.344 22.0828 21.344 22.3345C21.344 22.5861 21.1401 22.7901 20.8885 22.7901V22.7901Z"
                  fill="white"
                />
                <path
                  d="M20.8886 21.1954H11.7055C11.4538 21.1954 11.2499 20.9914 11.2499 20.7398C11.2499 20.4882 11.4538 20.2842 11.7055 20.2842H20.8886C21.1402 20.2842 21.3442 20.4882 21.3442 20.7398C21.3442 20.9914 21.1402 21.1954 20.8886 21.1954Z"
                  fill="white"
                />
                <path
                  d="M12.1611 19.6002C11.9094 19.6002 11.7054 19.3962 11.7054 19.1445V8.6651C11.7054 8.41348 11.9094 8.20947 12.1611 8.20947C12.4127 8.20947 12.6167 8.41348 12.6167 8.6651V19.1445C12.6167 19.3962 12.4127 19.6002 12.1611 19.6002Z"
                  fill="white"
                />
              </svg>
              <svg
                v-if="
                  row.item.profile &&
                    row.item.profile.expertise &&
                    row.item.profile.expertise.includes('f')
                "
                class="mr-1"
                width="31"
                height="31"
                viewBox="0 0 31 31"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.5 31C24.0604 31 31 24.0604 31 15.5C31 6.93959 24.0604 0 15.5 0C6.93959 0 0 6.93959 0 15.5C0 24.0604 6.93959 31 15.5 31Z"
                  fill="#F6F28B"
                />
                <path
                  d="M11.226 8.40771C10.3024 8.41177 9.55279 9.15531 9.53763 10.0792H9.35966C8.42659 10.0792 7.6684 10.8333 7.66431 11.7664C7.66431 11.7665 7.66431 11.7666 7.66431 11.7666V20.8924C7.66431 20.8925 7.66431 20.8925 7.66431 20.8926C7.66839 21.8256 8.42237 22.5877 9.35948 22.5918H19.7737C20.6973 22.5877 21.4469 21.8441 21.4621 20.9202H21.64C22.5731 20.9202 23.3313 20.1661 23.3354 19.233C23.3354 19.233 23.3354 19.2329 23.3354 19.2328V10.107C23.3354 10.1069 23.3354 10.1068 23.3354 10.1068C23.3313 9.16996 22.5772 8.41181 21.6402 8.40772H11.226V8.40771ZM11.226 9.29902H11.2265H21.6403C22.0841 9.30298 22.4406 9.66321 22.4444 10.1073V12.0289L21.4652 13.2909V11.7666C21.4652 10.8334 20.7069 10.0792 19.7738 10.0792H10.4289C10.4437 9.64847 10.7918 9.3029 11.2261 9.29902H11.226ZM9.35948 10.9705H19.7737C20.2138 10.9705 20.5738 11.3229 20.5738 11.7666V14.0008C20.5183 14.0108 20.4625 14.0193 20.4105 14.0193H18.114C16.8385 14.0193 15.8019 15.056 15.8019 16.3315C15.8019 17.607 16.8384 18.6437 18.1139 18.6477H20.4063C20.4072 18.6477 20.4081 18.6477 20.4089 18.6477C20.4641 18.6447 20.5171 18.6383 20.5697 18.6325L20.5736 20.8925C20.5736 21.3363 20.2173 21.6965 19.7735 21.7004H9.35967H9.35921C8.91553 21.6965 8.55911 21.3363 8.55516 20.8924V11.7671V11.7666C8.55915 11.3268 8.91534 10.9705 9.35921 10.9705L9.35948 10.9705ZM22.4405 13.4856L22.4442 15.7621L21.2084 17.365C21.0186 17.6118 20.7219 17.7566 20.4099 17.7604H18.1143H18.1139C17.3277 17.7564 16.693 17.1215 16.693 16.3354C16.693 15.5494 17.3277 14.9146 18.1139 14.9106H20.4063C20.6876 14.9106 20.9652 14.8495 21.2186 14.727L21.219 14.7268C21.4886 14.6001 21.725 14.4084 21.9085 14.1718V14.1718L22.4405 13.4856ZM18.0504 15.8898C17.8055 15.8898 17.6048 16.0905 17.6048 16.3354C17.6048 16.5804 17.8055 16.7811 18.0504 16.7811H19.0055C19.2504 16.7811 19.4512 16.5804 19.4512 16.3354C19.4512 16.0905 19.2504 15.8898 19.0055 15.8898H18.0504ZM22.4443 17.219V19.2328C22.4402 19.6727 22.0841 20.0289 21.6402 20.0289H21.4651V18.3165C21.6315 18.2011 21.7833 18.0617 21.9118 17.906C21.9121 17.9056 21.9124 17.9052 21.9127 17.9048L22.4443 17.219Z"
                  fill="white"
                />
              </svg>
            </template>
            <template #cell(status)="row">
              <div class="status">
                <span
                  class="status-btn"
                  :style="{
                    background: getStatusColor(row.item.status)
                  }"
                >
                  {{ getStatus(row.item.status) }}
                </span>
              </div>
            </template>
            <template #cell(account)="row">
              <div
                v-if="row.item.profile && row.item.profile._account"
                class="status"
              >
                <span
                  v-if="row.item.profile"
                  class="status-btn"
                  :style="{
                    background: getStatusColor(row.item.profile._account.status)
                  }"
                >
                  {{ getStatus(row.item.profile._account.status) }}
                </span>
                <span v-if="row.item.profile">
                  Type:
                  {{ row.item.profile._account.type }}
                </span>
              </div>
            </template>
            <template #cell(actions)="row">
              <div class="actions">
                <b-link size="sm" @click="showEditEvent(row.item)" class="mt-2">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M2.66667 3.33333C2.48986 3.33333 2.32029 3.40357 2.19527 3.5286C2.07024 3.65362 2.00001 3.82319 2.00001 4V13.3333C2.00001 13.5101 2.07024 13.6797 2.19527 13.8047C2.32029 13.9298 2.48986 14 2.66667 14H12C12.1768 14 12.3464 13.9298 12.4714 13.8047C12.5964 13.6797 12.6667 13.5101 12.6667 13.3333V9.77333C12.6667 9.40514 12.9651 9.10667 13.3333 9.10667C13.7015 9.10667 14 9.40514 14 9.77333V13.3333C14 13.8638 13.7893 14.3725 13.4142 14.7475C13.0391 15.1226 12.5304 15.3333 12 15.3333H2.66667C2.13624 15.3333 1.62753 15.1226 1.25246 14.7475C0.877385 14.3725 0.666672 13.8638 0.666672 13.3333V4C0.666672 3.46957 0.877385 2.96086 1.25246 2.58579C1.62753 2.21071 2.13624 2 2.66667 2H6.22667C6.59486 2 6.89334 2.29848 6.89334 2.66667C6.89334 3.03486 6.59486 3.33333 6.22667 3.33333H2.66667Z"
                      fill="#B3C2CB"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M11.5286 0.862254C11.7889 0.601905 12.2111 0.601905 12.4714 0.862254L15.1381 3.52892C15.3984 3.78927 15.3984 4.21138 15.1381 4.47173L8.47141 11.1384C8.34639 11.2634 8.17682 11.3337 8 11.3337H5.33334C4.96515 11.3337 4.66667 11.0352 4.66667 10.667V8.00033C4.66667 7.82351 4.73691 7.65394 4.86193 7.52892L11.5286 0.862254ZM6.00001 8.27647V10.0003H7.72386L13.7239 4.00033L12 2.27647L6.00001 8.27647Z"
                      fill="#B3C2CB"
                    />
                  </svg>
                </b-link>
                <b-link
                  size="sm"
                  class="mt-2"
                  @click="showDeleteEvent(row.item)"
                >
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 12 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M1 3C1 2.72386 1.22386 2.5 1.5 2.5H10.5C10.7761 2.5 11 2.72386 11 3C11 3.27614 10.7761 3.5 10.5 3.5H1.5C1.22386 3.5 1 3.27614 1 3Z"
                      fill="#FF8C7D"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M5 1.5C4.86739 1.5 4.74022 1.55268 4.64645 1.64645C4.55268 1.74021 4.5 1.86739 4.5 2V2.5H7.5V2C7.5 1.86739 7.44732 1.74021 7.35355 1.64645C7.25979 1.55268 7.13261 1.5 7 1.5H5ZM8.5 2.5V2C8.5 1.60217 8.34196 1.22064 8.06066 0.93934C7.77936 0.658035 7.39782 0.5 7 0.5H5C4.60218 0.5 4.22064 0.658035 3.93934 0.93934C3.65804 1.22064 3.5 1.60217 3.5 2V2.5H2.5C2.22386 2.5 2 2.72386 2 3V10C2 10.3978 2.15804 10.7794 2.43934 11.0607C2.72064 11.342 3.10217 11.5 3.5 11.5H8.5C8.89783 11.5 9.27936 11.342 9.56066 11.0607C9.84196 10.7794 10 10.3978 10 10V3C10 2.72386 9.77614 2.5 9.5 2.5H8.5ZM3 3.5V10C3 10.1326 3.05268 10.2598 3.14645 10.3536C3.24021 10.4473 3.36739 10.5 3.5 10.5H8.5C8.63261 10.5 8.75978 10.4473 8.85355 10.3536C8.94732 10.2598 9 10.1326 9 10V3.5H3Z"
                      fill="#FF8C7D"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M5 5C5.27614 5 5.5 5.22386 5.5 5.5V8.5C5.5 8.77614 5.27614 9 5 9C4.72386 9 4.5 8.77614 4.5 8.5V5.5C4.5 5.22386 4.72386 5 5 5Z"
                      fill="#FF8C7D"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M7 5C7.27614 5 7.5 5.22386 7.5 5.5V8.5C7.5 8.77614 7.27614 9 7 9C6.72386 9 6.5 8.77614 6.5 8.5V5.5C6.5 5.22386 6.72386 5 7 5Z"
                      fill="#FF8C7D"
                    />
                  </svg>
                </b-link>
              </div>
            </template>
            <template #cell(show_details)="row">
              <b-icon
                v-if="row.detailsShowing"
                @click="row.toggleDetails"
                icon="chevron-compact-up"
                font-scale="2"
              >
              </b-icon>
              <b-icon
                v-else
                @click="row.toggleDetails"
                icon="chevron-compact-down"
                font-scale="2"
              >
              </b-icon>
            </template>
            <template #row-details="row">
              <b-card>
                <b-row class="mb-2">
                  <b-col sm="3" class="text-sm-right"><b>Bio:</b></b-col>
                  <b-col v-if="row.item.profile && row.item.profile.bio">{{
                    row.item.profile.bio
                  }}</b-col>
                  <b-col v-else>No Bio</b-col>
                </b-row>

                <b-row class="mb-2">
                  <b-col sm="3" class="text-sm-right"
                    ><b>Last Published:</b></b-col
                  >
                  <b-col
                    class="table-published"
                    v-if="row.item.profile && row.item.profile._published_at"
                  >
                    <time-ago
                      :refresh="60"
                      :datetime="row.item.profile._published_at.toDate()"
                    ></time-ago>
                    Ago
                  </b-col>
                  <b-col v-else>Never</b-col>
                </b-row>
                <b-row class="mb-2">
                  <b-col sm="3" class="text-sm-right"><b>Phone #:</b></b-col>
                  <b-col v-if="row.item.event && row.item.event.phoneNumber">{{
                    row.item.event.phoneNumber
                  }}</b-col>
                  <b-col v-else>No Phone Number</b-col>
                </b-row>
              </b-card>
            </template>
          </b-table>
        </b-card>
        <b-pagination
          v-model="currentPage"
          :total-rows="items.length"
          :per-page="perPage"
          align="left"
          size="sm"
          class="my-0"
        ></b-pagination>
      </div>
      <modal :id="eventModal">
        <div class="add-event" v-if="!del">
          <span class="close-icon" @click="$bvModal.hide(eventModal)">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="12" cy="12" r="12" fill="#E4E6EB" />
              <g clip-path="url(#clip0)">
                <path
                  d="M12.5891 12.0006L17.2111 7.37855C17.3739 7.21582 17.3739 6.95199 17.2111 6.78928C17.0484 6.62657 16.7846 6.62655 16.6219 6.78928L11.9998 11.4113L7.37782 6.78928C7.21509 6.62655 6.95126 6.62655 6.78855 6.78928C6.62584 6.95201 6.62582 7.21584 6.78855 7.37855L11.4106 12.0006L6.78855 16.6226C6.62582 16.7853 6.62582 17.0492 6.78855 17.2119C6.8699 17.2932 6.97655 17.3339 7.0832 17.3339C7.18984 17.3339 7.29647 17.2932 7.37784 17.2119L11.9998 12.5899L16.6218 17.2119C16.7032 17.2932 16.8098 17.3339 16.9165 17.3339C17.0231 17.3339 17.1298 17.2932 17.2111 17.2119C17.3739 17.0491 17.3739 16.7853 17.2111 16.6226L12.5891 12.0006Z"
                  fill="#606770"
                />
              </g>
              <defs>
                <clipPath id="clip0">
                  <rect
                    width="10.6667"
                    height="10.6667"
                    fill="white"
                    transform="translate(6.6665 6.66675)"
                  />
                </clipPath>
              </defs>
            </svg>
          </span>
          <h3>{{ add ? "Add" : "Edit" }} Event</h3>
          <div class="h-18"></div>
          <b-form-group label="Name">
            <b-form-input
              type="text"
              required
              :disabled="notEditable"
              v-model="event.name"
              placeholder="Full Event Name (including Corp., LLC)"
            ></b-form-input>
          </b-form-group>
          <b-form-group label="Super-Admin Email">
            <b-form-input
              type="text"
              required
              :disabled="notEditable"
              v-model="event.email"
              placeholder="Email"
            ></b-form-input>
          </b-form-group>
          <b-form-group label="Phone #">
            <b-form-input
              type="text"
              required
              :disabled="notEditable"
              v-model="event.phoneNumber"
              placeholder="Event Phone"
            ></b-form-input>
          </b-form-group>
          <b-form-group label="Category">
            <b-form-input
              type="text"
              required
              v-model="event.category"
              placeholder="Event Category"
            ></b-form-input>
          </b-form-group>
          <b-form-group label="Profile Name (@)">
            <b-form-input
              type="text"
              required
              :disabled="notEditable"
              v-model="event.profileName"
              placeholder="Profile Name"
            ></b-form-input>
          </b-form-group>
          <b-form-group label="Bio" label-for="bio">
            <b-form-textarea
              id="bio"
              v-model="event.bio"
              :disabled="notEditable"
              placeholder="Event bio"
              rows="2"
              no-resize
            ></b-form-textarea>
            <!-- <span class="counter">{{ bio.length }}/300</span> -->
          </b-form-group>
          <b-form-group label="Upload Event Picture">
            <img
              v-if="imgDataUrl"
              class="event-image"
              :src="imgDataUrl"
              alt="Event Image"
            />
            <b-link
              v-if="imgDataUrl"
              variant="primary btn-round-fill"
              :disabled="notEditable"
              @click="showUpload = !showUpload"
            >
              Update
            </b-link>
            <b-button
              v-else
              variant="primary btn-round-fill"
              :disabled="notEditable"
              @click="showUpload = !showUpload"
            >
              Upload
            </b-button>
          </b-form-group>
          <my-upload
            langType="en"
            field="img"
            @crop-success="cropSuccess"
            @crop-upload-success="cropUploadSuccess"
            @crop-upload-fail="cropUploadFail"
            v-model="showUpload"
            :width="300"
            :height="300"
            :params="params"
            :headers="headers"
            img-format="png"
            :noSquare="true"
          >
          </my-upload>
          <b-form-group label="Select your focus Areas">
            <div class="areas">
              <div class="spiritual">
                <h6>Spiritual</h6>
                <svg
                  @click="toggleExpertise('s')"
                  width="31"
                  height="31"
                  viewBox="0 0 31 31"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.5 31C24.0604 31 31 24.0604 31 15.5C31 6.93959 24.0604 0 15.5 0C6.93958 0 0 6.93959 0 15.5C0 24.0604 6.93958 31 15.5 31Z"
                    :fill="
                      event.expertise.includes('s')
                        ? 'var(--theme-color)'
                        : '#ddd'
                    "
                  />
                  <path
                    d="M16.8568 7.25651C16.7516 7.25492 16.6502 7.29588 16.5764 7.37083L14.5994 9.3367C14.5274 9.40868 14.4614 9.48604 14.395 9.56309C13.6597 8.95221 12.7373 8.60899 11.7789 8.60976H10.8973C10.6823 8.60976 10.5052 8.78694 10.5052 9.00196V10.5052H9.00191C8.78689 10.5052 8.61013 10.682 8.61013 10.897V11.7786C8.61021 12.0739 8.65073 12.3671 8.71363 12.6555C8.44879 12.8217 8.19786 13.01 7.97689 13.2314L7.3712 13.8371C7.2192 13.9891 7.2192 14.2391 7.3712 14.3911L9.36256 16.3828C9.4328 16.4531 9.50822 16.5171 9.58306 16.5816C8.95993 17.3204 8.60936 18.252 8.61013 19.2211V20.1026C8.61015 20.3176 8.78689 20.4944 9.00191 20.4944H10.5052V21.9977C10.5052 22.2127 10.6824 22.3898 10.8974 22.3898H11.7789C12.0865 22.3898 12.3914 22.3462 12.6912 22.2781C12.8553 22.5379 13.0405 22.7844 13.258 23.0017L13.8657 23.6252C13.9386 23.7001 14.0385 23.7426 14.1431 23.7434H14.1456C14.2491 23.7434 14.3487 23.7024 14.4221 23.6294L16.4001 21.6629V21.6627C16.4719 21.5906 16.5379 21.5134 16.6042 21.4363C17.3397 22.0475 18.2619 22.3907 19.2207 22.3899H20.1021C20.3172 22.3899 20.4943 22.2128 20.4943 21.9977V20.4945H21.9976C22.2127 20.4945 22.3894 20.3177 22.3894 20.1027V19.2208C22.3894 18.9255 22.3488 18.6325 22.2859 18.3442C22.5507 18.178 22.8013 17.9899 23.0223 17.7685L23.6283 17.1625C23.7804 17.0105 23.7804 16.7603 23.6283 16.6082L21.6369 14.6165C21.5667 14.5464 21.4913 14.4825 21.4165 14.418C22.0396 13.6792 22.3902 12.7477 22.3894 11.7787V10.8971C22.3894 10.6821 22.2127 10.5053 21.9976 10.5053H20.4943V9.00194C20.4943 8.78692 20.3172 8.60983 20.1021 8.60983H19.2207C18.9131 8.60986 18.6077 8.65337 18.308 8.72155C18.1442 8.46208 17.9596 8.21605 17.7425 7.99895L17.7406 7.99768L17.1329 7.37431C17.0601 7.29954 16.9602 7.25732 16.8558 7.25635L16.8568 7.25651ZM16.8489 8.20525L17.183 8.54787L17.1859 8.55072C18.4849 9.85272 18.4848 11.9568 17.1859 13.2589L16.8058 13.6389C16.5318 13.446 16.2213 13.317 15.8912 13.2591V12.7229C15.8912 11.7705 15.5541 10.8533 14.95 10.1199C15.0151 10.0417 15.0806 9.96392 15.1525 9.89192V9.89165L16.8489 8.20525ZM11.2887 9.39373H11.7782C13.6175 9.39563 15.1054 10.8837 15.1074 12.723V13.2616C14.2636 13.4116 13.5855 14.0165 13.3319 14.8326C12.1048 14.3109 11.2922 13.1198 11.2887 11.7786V11.7783V9.39373ZM19.2207 9.39373H19.7105V10.5052H19.2207C19.1198 10.5053 19.0191 10.5132 18.9186 10.5206C18.8849 10.1539 18.8001 9.79533 18.67 9.45102C18.8524 9.42046 19.0356 9.39378 19.2207 9.39373V9.39373ZM9.39369 11.2888H10.5049V11.7786C10.5049 11.8708 10.5121 11.9612 10.5183 12.0518C10.1505 12.0835 9.79054 12.1665 9.4448 12.2955C9.41791 12.1242 9.39381 11.9521 9.39373 11.7786L9.39369 11.2888ZM19.2207 11.2888H21.6055V11.7786C21.6036 13.6178 20.1158 15.1056 18.2766 15.1078H17.74C17.6822 14.7777 17.5536 14.467 17.3606 14.1929L17.74 13.8135V13.8132C18.4156 13.1413 18.826 12.2534 18.917 11.3072C19.0179 11.2979 19.119 11.289 19.2203 11.2889L19.2207 11.2888ZM10.6523 12.8262C10.9054 13.7741 11.4905 14.5876 12.2922 15.1452C11.5056 15.2281 10.7597 15.5294 10.1432 16.0297C10.0654 15.9651 9.98817 15.8999 9.9165 15.8285L8.20228 14.1139L8.53112 13.785C9.09703 13.2148 9.85237 12.8789 10.652 12.8262H10.6523ZM15.5053 13.9926C15.5587 13.9932 15.6119 13.9969 15.6647 14.0032C15.8056 14.0201 15.9437 14.0567 16.0748 14.111C16.5994 14.3282 17.0029 14.8248 17.0029 15.4997C17.001 16.3309 16.3309 17.0018 15.4997 17.003C14.8248 17.003 14.3279 16.5998 14.1106 16.0752C13.8933 15.5506 13.9595 14.9141 14.4366 14.437C14.7497 14.1239 15.1316 13.9877 15.5053 13.9926V13.9926ZM20.856 14.9699H20.8561C20.9338 15.0346 21.011 15.0997 21.0827 15.1711L22.7973 16.8854L22.4681 17.2145C21.9021 17.7846 21.1468 18.1207 20.3473 18.1734C20.0942 17.2256 19.509 16.4121 18.7074 15.8544C19.494 15.7715 20.2397 15.4702 20.8563 14.9699H20.856ZM12.7226 15.8918H12.7227H13.2589C13.3168 16.2219 13.4457 16.5324 13.6386 16.8064L13.2592 17.1861C12.5834 17.858 12.1729 18.7458 12.0819 19.6921C11.9809 19.7015 11.8797 19.7103 11.7782 19.7105H9.39369V19.221C9.39559 17.3819 10.8835 15.8941 12.7226 15.8918V15.8918ZM17.6673 16.1669C18.8946 16.6887 19.7072 17.8797 19.7105 19.2211V21.6059H19.2207C17.3814 21.604 15.8935 20.116 15.8914 18.2766V17.7381C16.7354 17.5882 17.4137 16.9831 17.6673 16.1669ZM14.1929 17.3607C14.467 17.5536 14.7776 17.6825 15.1078 17.7403V18.2766C15.1078 19.2289 15.4448 20.1459 16.0486 20.8793C15.9837 20.9576 15.9183 21.0355 15.8465 21.1076L14.1503 22.7944L13.8145 22.4498C13.8145 22.4501 13.8145 22.4491 13.8145 22.4495V22.4492V22.4489C12.5134 21.1478 12.5134 19.042 13.8145 17.7409L14.1929 17.3607ZM21.5544 18.7038C21.5813 18.8752 21.6054 19.0474 21.6055 19.2211V19.7105H20.4944V19.2211C20.4944 19.1287 20.4871 19.0382 20.4809 18.9475C20.8488 18.9159 21.2085 18.8328 21.5543 18.7038H21.5544ZM12.0806 20.479C12.1143 20.8456 12.1987 21.2042 12.3288 21.5485C12.1466 21.5791 11.9635 21.6059 11.7785 21.6059H11.2888V20.4944H11.7785C11.8794 20.4943 11.9801 20.4863 12.0806 20.4789V20.479Z"
                    fill="white"
                  />
                </svg>
              </div>
              <div class="health">
                <h6>Health</h6>
                <svg
                  @click="toggleExpertise('h')"
                  width="31"
                  height="31"
                  viewBox="0 0 31 31"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.5 31C24.0604 31 31 24.0604 31 15.5C31 6.93959 24.0604 0 15.5 0C6.93959 0 0 6.93959 0 15.5C0 24.0604 6.93959 31 15.5 31Z"
                    :fill="event.expertise.includes('h') ? '#FF8C7D' : '#ddd'"
                  />
                  <path
                    d="M11.7163 7.92725C10.4068 7.92725 9.20456 8.45094 8.32717 9.40254C7.46019 10.343 6.98157 11.6289 6.98157 13.0251C6.98157 14.4615 7.51479 15.7744 8.66947 17.1677C9.70254 18.4142 11.1926 19.6848 12.9201 21.157C12.921 21.1577 12.922 21.1585 12.9229 21.1593C13.5122 21.6614 14.1799 22.231 14.8729 22.837C15.0462 22.9888 15.2686 23.072 15.4994 23.072C15.73 23.072 15.9527 22.9885 16.1258 22.837C16.8204 22.2295 17.4891 21.6595 18.0793 21.1566C19.8066 19.6845 21.2965 18.4139 22.3296 17.1673C23.4843 15.7741 24.0179 14.4615 24.0179 13.0251C24.0179 11.6289 23.5392 10.343 22.6722 9.40254C21.7949 8.45094 20.5925 7.92725 19.2831 7.92725C18.305 7.92725 17.4115 8.23585 16.6225 8.84606C16.2242 9.15407 15.863 9.53126 15.5441 9.97199C15.539 9.97904 15.5323 9.98476 15.5245 9.98871C15.5167 9.99267 15.5081 9.99473 15.4993 9.99473C15.4906 9.99473 15.482 9.99267 15.4742 9.98871C15.4665 9.98476 15.4597 9.97904 15.4545 9.97199C15.1358 9.53126 14.7747 9.15407 14.3766 8.84606C13.5876 8.23586 12.6941 7.92725 11.716 7.92725H11.7163ZM11.7163 8.82091C12.4902 8.82091 13.2031 9.06806 13.8299 9.55266C14.3887 9.98484 14.7755 10.5286 15.0026 10.9093C15.1085 11.0868 15.2933 11.1918 15.4997 11.1918C15.7061 11.1918 15.8909 11.0868 15.9968 10.9093C16.224 10.5286 16.6108 9.98484 17.1695 9.55266C17.7962 9.06806 18.5091 8.82091 19.283 8.82091C20.3381 8.82091 21.31 9.2429 22.0155 10.0081C22.7315 10.7849 23.1245 11.8567 23.1245 13.0251C23.1245 14.2586 22.6636 15.3649 21.6422 16.5974C20.6547 17.789 19.1921 19.0345 17.5004 20.4763C16.9078 20.9811 16.2364 21.5535 15.5347 22.1646C15.5245 22.1734 15.5116 22.1783 15.4981 22.1783C15.4847 22.1783 15.4717 22.1734 15.4616 22.1646C14.765 21.5556 14.0961 20.9849 13.5052 20.4814L13.5021 20.479C13.5011 20.4783 13.5001 20.4775 13.4992 20.4767C11.8074 19.0349 10.3445 17.789 9.35706 16.5975C8.33555 15.3649 7.87469 14.2586 7.87469 13.0252C7.87469 11.8568 8.26769 10.7849 8.98374 10.0082C9.68935 9.24293 10.661 8.82092 11.7162 8.82092L11.7163 8.82091Z"
                    fill="white"
                  />
                </svg>
              </div>
              <div class="finance">
                <h6>Education</h6>
                <svg
                  @click="toggleExpertise('e')"
                  width="31"
                  height="31"
                  viewBox="0 0 31 31"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.5 31C24.0604 31 31 24.0604 31 15.5C31 6.93959 24.0604 0 15.5 0C6.93959 0 0 6.93959 0 15.5C0 24.0604 6.93959 31 15.5 31Z"
                    :fill="event.expertise.includes('e') ? '#65EA82' : '#ddd'"
                  />
                  <path
                    d="M10.1106 21.1949C9.85899 21.1949 9.65503 20.9909 9.65503 20.7393V10.0889C9.65503 9.05258 10.4982 8.20947 11.5345 8.20947H20.8885C21.1401 8.20947 21.344 8.41348 21.344 8.6651V19.1446C21.344 19.3962 21.1401 19.6002 20.8885 19.6002C20.6368 19.6002 20.4328 19.3962 20.4328 19.1446V9.12073H11.5345C11.0006 9.12073 10.5663 9.55506 10.5663 10.0889V20.7393C10.5663 20.9909 10.3623 21.1949 10.1106 21.1949V21.1949Z"
                    fill="white"
                  />
                  <path
                    d="M20.8885 22.7901H11.7054C10.5748 22.7901 9.65503 21.8703 9.65503 20.7398C9.65503 19.6092 10.5748 18.6895 11.7054 18.6895H20.8885C21.1401 18.6895 21.344 18.8935 21.344 19.1451C21.344 19.3967 21.1401 19.6007 20.8885 19.6007H11.7054C11.0773 19.6007 10.5663 20.1117 10.5663 20.7398C10.5663 21.3679 11.0773 21.8788 11.7054 21.8788H20.8885C21.1401 21.8788 21.344 22.0828 21.344 22.3345C21.344 22.5861 21.1401 22.7901 20.8885 22.7901V22.7901Z"
                    fill="white"
                  />
                  <path
                    d="M20.8886 21.1954H11.7055C11.4538 21.1954 11.2499 20.9914 11.2499 20.7398C11.2499 20.4882 11.4538 20.2842 11.7055 20.2842H20.8886C21.1402 20.2842 21.3442 20.4882 21.3442 20.7398C21.3442 20.9914 21.1402 21.1954 20.8886 21.1954Z"
                    fill="white"
                  />
                  <path
                    d="M12.1611 19.6002C11.9094 19.6002 11.7054 19.3962 11.7054 19.1445V8.6651C11.7054 8.41348 11.9094 8.20947 12.1611 8.20947C12.4127 8.20947 12.6167 8.41348 12.6167 8.6651V19.1445C12.6167 19.3962 12.4127 19.6002 12.1611 19.6002Z"
                    fill="white"
                  />
                </svg>
              </div>
              <div class="finance">
                <h6>Finance</h6>
                <svg
                  @click="toggleExpertise('f')"
                  width="31"
                  height="31"
                  viewBox="0 0 31 31"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.5 31C24.0604 31 31 24.0604 31 15.5C31 6.93959 24.0604 0 15.5 0C6.93959 0 0 6.93959 0 15.5C0 24.0604 6.93959 31 15.5 31Z"
                    :fill="event.expertise.includes('f') ? '#F6F28B' : '#ddd'"
                  />
                  <path
                    d="M11.226 8.40771C10.3024 8.41177 9.55279 9.15531 9.53763 10.0792H9.35966C8.42659 10.0792 7.6684 10.8333 7.66431 11.7664C7.66431 11.7665 7.66431 11.7666 7.66431 11.7666V20.8924C7.66431 20.8925 7.66431 20.8925 7.66431 20.8926C7.66839 21.8256 8.42237 22.5877 9.35948 22.5918H19.7737C20.6973 22.5877 21.4469 21.8441 21.4621 20.9202H21.64C22.5731 20.9202 23.3313 20.1661 23.3354 19.233C23.3354 19.233 23.3354 19.2329 23.3354 19.2328V10.107C23.3354 10.1069 23.3354 10.1068 23.3354 10.1068C23.3313 9.16996 22.5772 8.41181 21.6402 8.40772H11.226V8.40771ZM11.226 9.29902H11.2265H21.6403C22.0841 9.30298 22.4406 9.66321 22.4444 10.1073V12.0289L21.4652 13.2909V11.7666C21.4652 10.8334 20.7069 10.0792 19.7738 10.0792H10.4289C10.4437 9.64847 10.7918 9.3029 11.2261 9.29902H11.226ZM9.35948 10.9705H19.7737C20.2138 10.9705 20.5738 11.3229 20.5738 11.7666V14.0008C20.5183 14.0108 20.4625 14.0193 20.4105 14.0193H18.114C16.8385 14.0193 15.8019 15.056 15.8019 16.3315C15.8019 17.607 16.8384 18.6437 18.1139 18.6477H20.4063C20.4072 18.6477 20.4081 18.6477 20.4089 18.6477C20.4641 18.6447 20.5171 18.6383 20.5697 18.6325L20.5736 20.8925C20.5736 21.3363 20.2173 21.6965 19.7735 21.7004H9.35967H9.35921C8.91553 21.6965 8.55911 21.3363 8.55516 20.8924V11.7671V11.7666C8.55915 11.3268 8.91534 10.9705 9.35921 10.9705L9.35948 10.9705ZM22.4405 13.4856L22.4442 15.7621L21.2084 17.365C21.0186 17.6118 20.7219 17.7566 20.4099 17.7604H18.1143H18.1139C17.3277 17.7564 16.693 17.1215 16.693 16.3354C16.693 15.5494 17.3277 14.9146 18.1139 14.9106H20.4063C20.6876 14.9106 20.9652 14.8495 21.2186 14.727L21.219 14.7268C21.4886 14.6001 21.725 14.4084 21.9085 14.1718V14.1718L22.4405 13.4856ZM18.0504 15.8898C17.8055 15.8898 17.6048 16.0905 17.6048 16.3354C17.6048 16.5804 17.8055 16.7811 18.0504 16.7811H19.0055C19.2504 16.7811 19.4512 16.5804 19.4512 16.3354C19.4512 16.0905 19.2504 15.8898 19.0055 15.8898H18.0504ZM22.4443 17.219V19.2328C22.4402 19.6727 22.0841 20.0289 21.6402 20.0289H21.4651V18.3165C21.6315 18.2011 21.7833 18.0617 21.9118 17.906C21.9121 17.9056 21.9124 17.9052 21.9127 17.9048L22.4443 17.219Z"
                    fill="white"
                  />
                </svg>
              </div>
            </div>
          </b-form-group>

          <b-form-group label="Status">
            <b-form-select
              v-model="event.status"
              :options="statusOptions"
            ></b-form-select>
          </b-form-group>

          <b-form-group label="Account Status">
            <b-form-select
              v-model="event.accountStatus"
              :options="accountStatusOptions"
              :disabled="!notEditable"
            ></b-form-select>
          </b-form-group>

          <b-form-group label="Account Type">
            <b-form-select
              v-model="event.accountType"
              :options="accountTypeOptions"
              :disabled="!notEditable"
            ></b-form-select>
          </b-form-group>

          <div class="d-flex justify-content-between">
            <b-button
              variant="light btn-simple"
              @click="$bvModal.hide(eventModal)"
            >
              Cancel
            </b-button>
            <b-button
              variant="primary btn-round-fill "
              v-if="add"
              @click="addEvent"
              :disabled="
                event.email.trim().length > 0 && event.status !== null
                  ? false
                  : true
              "
            >
              Add
            </b-button>
            <b-button
              variant="primary btn-round-fill"
              @click="editEvent"
              v-else
              :disabled="
                event.email.trim().length > 0 && event.status !== null
                  ? false
                  : true
              "
            >
              Update
            </b-button>
          </div>
        </div>
        <div class="add-event del-event" v-else>
          <span class="close-icon" @click="$bvModal.hide(eventModal)">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="12" cy="12" r="12" fill="#E4E6EB" />
              <g clip-path="url(#clip0)">
                <path
                  d="M12.5891 12.0006L17.2111 7.37855C17.3739 7.21582 17.3739 6.95199 17.2111 6.78928C17.0484 6.62657 16.7846 6.62655 16.6219 6.78928L11.9998 11.4113L7.37782 6.78928C7.21509 6.62655 6.95126 6.62655 6.78855 6.78928C6.62584 6.95201 6.62582 7.21584 6.78855 7.37855L11.4106 12.0006L6.78855 16.6226C6.62582 16.7853 6.62582 17.0492 6.78855 17.2119C6.8699 17.2932 6.97655 17.3339 7.0832 17.3339C7.18984 17.3339 7.29647 17.2932 7.37784 17.2119L11.9998 12.5899L16.6218 17.2119C16.7032 17.2932 16.8098 17.3339 16.9165 17.3339C17.0231 17.3339 17.1298 17.2932 17.2111 17.2119C17.3739 17.0491 17.3739 16.7853 17.2111 16.6226L12.5891 12.0006Z"
                  fill="#606770"
                />
              </g>
              <defs>
                <clipPath id="clip0">
                  <rect
                    width="10.6667"
                    height="10.6667"
                    fill="white"
                    transform="translate(6.6665 6.66675)"
                  />
                </clipPath>
              </defs>
            </svg>
          </span>
          <h3>Delete Event</h3>
          <div class="warning-msg">
            <p>
              Are you sure want to delete
              <strong v-if="selectedEvent && selectedEvent.event">
                {{ selectedEvent.event.name }}
              </strong>
              Event?
            </p>
          </div>
          <div class="d-flex justify-content-between">
            <b-button variant="danger btn-round-fill" @click="deleteEvent">
              Yes! Delete
            </b-button>
            <b-button variant="light btn-simple" @click="hideDeleteEvent">
              No! back
            </b-button>
          </div>
        </div>
      </modal>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import firebase from "firebase";
import { mapGetters } from "vuex";
import TimeAgo from "vue2-timeago";
import MyUpload from "vue-image-crop-upload";
import Modal from "@/components/common/modal";
export default {
  data() {
    return {
      eventModal: "admin-event-modal",
      searchStr: "",
      add: true,
      edit: false,
      del: false,
      input: "",
      imgDataUrl: "",
      activeIndex: -1,
      event: {
        name: "",
        email: "",
        phoneNumber: "",
        profileName: "",
        imgURL: null,
        expertise: [],
        category: "",
        bio: "",
        status: null,
        accountType: null,
        accountStatus: null
      },
      statusOptions: [
        { value: null, text: "Please select an option" },
        { value: "active", text: "Active" },
        { value: "inactive", text: "Inactive" }
      ],
      accountTypeOptions: [
        { value: null, text: "Please select an option" },
        { value: "free", text: "Free" },
        { value: "starter", text: "Starter" },
        { value: "premium", text: "Premium" }
      ],
      accountStatusOptions: [
        { value: null, text: "Please select an option" },
        { value: "active", text: "Active" },
        { value: "inactive", text: "Inactive" }
      ],
      showUpload: false,
      params: {
        token: "123456798",
        name: "avatar"
      },
      headers: {
        smail: "*_~"
      },
      selectedEvent: null,
      transProps: {
        name: "flip-list" // Transition name
      },
      fields: [
        { key: "Index", sortable: false, label: "Ind" },
        { key: "imgURL", sortable: false, label: "" },
        { key: "event.name", sortable: true, label: "Name" },
        { key: "event.email", sortable: false, label: "Email" },
        {
          key: "spheres",
          sortable: false,
          label: "Expertise"
        },
        {
          key: "_created_at",
          label: "Joined",
          sortable: false,
          formatter: "formatDate"
        },
        {
          key: "status",
          label: "Status",
          sortable: false
        },
        {
          key: "account",
          label: "Account Status",
          sortable: false
        },
        { key: "actions", label: "Actions" },
        { key: "show_details", label: "Show Details" }
      ],
      currentPage: 1,
      perPage: 50,
      pageOptions: [5, 10, 15, { value: 100, text: "Show a lot" }]
    };
  },
  props: {
    profile: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    Modal,
    TimeAgo,
    MyUpload
  },
  computed: {
    ...mapGetters({
      items: "admin/companies"
    }),
    events() {
      if (this.searchStr.trim() == "") return this.items;
      let filteredItems = [];

      filteredItems = this.items.filter(event => {
        return (
          event.event.firstname
            .toLowerCase()
            .includes(this.searchStr.toLowerCase().trim()) ||
          event.uer.lastname
            .toLowerCase()
            .includes(this.searchStr.toLowerCase().trim())
        );
      });

      return filteredItems;
    },
    notEditable() {
      let notEditable = false;
      if (
        this.selectedEvent &&
        this.selectedEvent.event &&
        this.selectedEvent.event.eventId
      ) {
        notEditable = true;
      }
      return notEditable;
    }
  },
  mounted() {},
  methods: {
    handleActivation() {
      this.getCompanies();
    },
    getCompanies() {
      this.$store.dispatch("admin/getCompanies");
    },
    getStatus(status) {
      if (status == "active") {
        return "Active";
      } else return "In Active";
    },
    getStatusColor(status) {
      if (status == "active") {
        return "#4BB543";
      } else return "#FF0000";
    },
    formatDate(date) {
      return date
        ? moment(date.toDate()).format("MMMM DD, YYYY h:MM a")
        : "N/A";
    },
    toggleExpertise(e) {
      if (this.notEditable) {
        return;
      }
      if (this.event.expertise.includes(e)) {
        let index = this.event.expertise.indexOf(e);
        this.event.expertise.splice(index, 1);
      } else {
        this.event.expertise.push(e);
      }
    },
    resetForm() {
      this.imgDataUrl = "";
      this.event = {
        name: "",
        email: "",
        phoneNumber: "",
        imgURL: null,
        category: "",
        bio: "",
        profileName: "",
        status: null,
        expertise: [],
        accountType: null,
        accountStatus: null
      };
    },
    showAddEvent() {
      this.del = false;
      this.edit = false;
      this.add = true;
      this.resetForm();
      this.selectedEvent = null;
      this.$bvModal.show(this.eventModal);
    },
    addEvent() {
      this.$store
        .dispatch("admin/addNewEvent", {
          event: this.event,
          createdBy: this.profile.userId
        })
        .then(res => {
          this.$bvModal.hide(this.eventModal);
          this.getCompanies();
        });
    },
    showEditEvent(event) {
      console.log(event);
      this.del = false;
      this.add = false;
      this.edit = true;
      this.resetForm();
      this.selectedEvent = event;
      this.event.name = event.event.name;
      this.event.email = event.event.email;
      this.event.imgURL = event.event.imgURL;
      this.imgDataUrl = event.event.imgURL;
      this.event.phoneNumber = event.event.phoneNumber;
      this.event.category = event.category ? event.category : "";
      this.event.expertise =
        event.profile && event.profile.expertise ? event.profile.expertise : [];
      this.event.profileName =
        event.profile && event.profile.profileName
          ? event.profile.profileName
          : "";
      this.event.bio =
        event.profile && event.profile.bio ? event.profile.bio : "";
      this.event.status = event.status ? event.status : null;
      this.event.accountStatus =
        event.profile && event.profile._account
          ? event.profile._account.status
          : null;
      this.event.accountType =
        event.profile && event.profile._account
          ? event.profile._account.type
          : null;
      this.$bvModal.show(this.eventModal);
    },
    editEvent() {
      this.$store
        .dispatch("admin/updateEvent", {
          event: this.event,
          updatedBy: this.profile.userId
        })
        .then(res => {
          this.$bvModal.hide(this.eventModal);
          this.resetForm();
          this.getCompanies();
        });
    },
    showDeleteEvent(event) {
      this.add = false;
      this.edit = false;
      this.del = true;
      this.selectedEvent = event;
      this.$bvModal.show(this.eventModal);
    },
    hideDeleteEvent() {
      this.selectedEvent = null;
      this.$bvModal.hide(this.eventModal);
    },
    deleteEvent() {
      console.log(this.selectedEvent);
      this.$store
        .dispatch("admin/deleteEvent", {
          event: this.selectedEvent,
          deletedBy: this.profile.userId
        })
        .then(res => {
          this.$bvModal.hide(this.eventModal);
          this.resetForm();
          this.getCompanies();
        });
    },
    cropSuccess(imgDataUrl, field) {
      this.imgDataUrl = imgDataUrl;
      this.uploadImage(imgDataUrl);
    },
    cropUploadSuccess(jsonData, field) {
      console.log(jsonData);
      console.log("field: " + field);
    },
    cropUploadFail(status, field) {
      console.log(status);
      console.log("field: " + field);
    },
    uploadImage(imgDataUrl) {
      let result = "";
      var characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      var charactersLength = characters.length;
      for (var i = 0; i < 15; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }
      var storageRef = firebase.storage().ref(`event_img/${result}`);

      var metadata = {
        contentType: "image/jpeg"
      };
      var uploadTask = storageRef.putString(imgDataUrl, "data_url");

      uploadTask.on(
        "state_changed",
        snapshot => {
          var progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          console.log("Upload is " + progress + "% done");
          switch (snapshot.state) {
            case firebase.storage.TaskState.PAUSED: // or 'paused'
              console.log("Upload is paused");
              break;
            case firebase.storage.TaskState.RUNNING: // or 'running'
              console.log("Upload is running");
              break;
          }
        },
        error => {
          console.log("Error uploading image: ", error);
        },
        () => {
          uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
            console.log(downloadURL);
            this.event.imgURL = downloadURL;
          });
        }
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.add-events {
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 19px;
  color: var(--theme-color);
  cursor: pointer;
  position: relative;
}
.add-event {
  .close-icon {
    position: absolute;
    top: 24px;
    right: 20px;
    cursor: pointer;
  }
  .btn-round-fill {
    max-width: 160px;
    width: 100%;
  }
  input {
    margin-top: 5px;
    margin-bottom: 10px;
  }
  h3 {
    margin-bottom: 0;
    margin-top: 10px;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 33px;
    color: #474d52;
    text-align: center;
  }
}
.del-event {
  .warning-msg {
    margin: 24px 0;
    p {
      text-align: center;
      margin: 0;
    }
  }
  .btn-round-fill {
    background-color: #ef5c4a;
    border-color: #ef5c4a;
  }
  .btn-simple {
    color: #ef5c4a;
    font-weight: bold;
  }
}

.search {
  cursor: pointer;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
  color: #8d99a0;
}
.card-guide {
  box-shadow: none;
}
.events {
  margin-top: 20px;
  .card {
    border: none;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
    .card-text {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 19px;
      display: flex;
      align-items: center;
      color: #474d52;
    }
  }

  .card-header {
    display: grid;
    grid-template-columns: 1fr 30px;
    align-items: center;
    padding: 0;
    .edit,
    .delete {
      display: none;
      cursor: pointer;
    }
    .btn-collapse {
      padding: 24px;
      text-align: left;
      box-shadow: none;
    }
    &.active {
      grid-template-columns: 1fr 30px 30px 30px;
      .edit,
      .delete {
        display: block;
      }
      .btn-collapse {
        padding-bottom: 0px;
      }
    }

    border: none;
    box-shadow: none;
    background: none;
  }
}
.actions {
  display: flex;
  justify-content: space-evenly;
}
.status {
  margin-top: 0.5rem;
  display: flex;
  flex-direction: column;
  .status-btn {
    display: inline-block;
    margin-right: 15px;
    width: 105px;
    height: 21px;
    font-family: Nunito;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    color: #ffffff;
    background: var(--theme-color);
    text-align: center;
    border: none;
    border-radius: 3px;
  }
}
.event-image {
  width: 80px;
  height: 80px;
  border-radius: 50%;
}
.areas {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  & > div {
    width: 60px;
    h6 {
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 16px;
      color: #8d99a0;
    }
    svg {
      cursor: pointer;
    }
  }
}
#bio {
  border-radius: 5px;
}
</style>
